export const WHAT_THEY_SAY = {
  isShowPortalBanner: true,
  videoList: [
    {
      countryKey: 'Ecuador',
      videoPath: 'https://www.youtube.com/watch?v=koSb_zfF1zY',
      mapPath: '/assets/img/testimony_activity/web_map_Ecuador.svg',
      appMapPath: '/assets/img/testimony_activity/app_map_Ecuador.svg',
      isShow: true,
      createTime: 1620820000010,
      position: 'bottom',
      appPosition: 'center-right',
      textPosition: 'bottom-left',
      appTextPosition: 'bottom-left',
      videoThumbnail: '/assets/img/testimony_activity/image_1.jpg.webp'
    },
    {
      countryKey: 'UnitedKingdom',
      videoPath: 'https://www.youtube.com/watch?v=yLIGgi3y9L8&t=2s',
      mapPath: '/assets/img/testimony_activity/web_map_UK.svg',
      appMapPath: '/assets/img/testimony_activity/app_map_UK.svg',
      isShow: true,
      createTime: 1620820000010,
      position: 'top-left',
      appPosition: 'left',
      textPosition: 'left',
      appTextPosition: 'left',
      videoThumbnail: '/assets/img/testimony_activity/image_2.jpg.webp'
    },
    {
      countryKey: 'Thailand',
      videoPath: 'https://youtu.be/vaJOKb_Le0s',
      mapPath: '/assets/img/testimony_activity/web_map_Thailand.svg',
      appMapPath: '/assets/img/testimony_activity/app_map_Thailand.svg',
      isShow: true,
      createTime: 1620820000010,
      position: 'center',
      appPosition: 'center-left',
      textPosition: 'center-right',
      appTextPosition: 'bottom-right',
      videoThumbnail: '/assets/img/testimony_activity/image_3.png.webp'
    },
    {
      countryKey: 'Vietnam',
      videoPath: 'https://www.facebook.com/hikvisionvietnamofficial/videos/611278872869246/',
      mapPath: '/assets/img/testimony_activity/web_map_Vietnam.svg',
      appMapPath: '/assets/img/testimony_activity/app_map_Vietnam.svg',
      isShow: true,
      createTime: 1620820000010,
      position: 'center',
      appPosition: 'center-left',
      textPosition: 'center-right',
      appTextPosition: 'bottom-right',
      videoThumbnail: '/assets/img/testimony_activity/image_4.png.webp'
    }
  ],
  pictureList: [
    {
      titleKey: 'Dimitrios Zacharias',
      subTitleKey: 'Legio',
      countryKey: 'Ecuador',
      picturePath: '/assets/img/testimony_activity/web_Image_011.png.webp',
      appBgPath: '/assets/img/testimony_activity/app_Image_01.png',
      contentKey: 'testimony_images_content_1',
      isShow: true,
      icon: '/assets/img/testimony_activity/icon_1.svg',
      createTime: 1620820000010
    },
    {
      titleKey: 'James Lillistone',
      subTitleKey: 'Jay CCTV Solutions',
      countryKey: 'UnitedKingdom',
      picturePath: '/assets/img/testimony_activity/web_Image_021.png.webp',
      appBgPath: '/assets/img/testimony_activity/app_Image_02.png',
      contentKey: 'testimony_images_content_2',
      isShow: true,
      icon: '/assets/img/testimony_activity/icon_2.svg',
      createTime: 1620820000010
    },
    {
      titleKey: 'Allen Boquerin',
      subTitleKey: 'FGT Electronics Center and Radio Communication Supply',
      countryKey: 'Philippines',
      picturePath: '/assets/img/testimony_activity/web_Image_031.png.webp',
      appBgPath: '/assets/img/testimony_activity/app_Image_03.png',
      contentKey: 'testimony_images_content_3',
      isShow: true,
      icon: '/assets/img/testimony_activity/icon_3.svg',
      createTime: 1620820000010
    },
    {
      titleKey: 'Nguyễn Đức Tuấn',
      subTitleKey: 'công nghệ Đức Tuấn',
      countryKey: 'Vietnam',
      picturePath: '/assets/img/testimony_activity/web_Image_041.png.webp',
      appBgPath: '/assets/img/testimony_activity/app_Image_05.png',
      contentKey: 'testimony_images_content_5',
      isShow: true,
      icon: '/assets/img/testimony_activity/icon_5.svg',
      createTime: 1620820000010
    },
    {
      titleKey: 'Rıdvan Aydın',
      subTitleKey: 'Metsa Güvenlik',
      countryKey: 'Turkey',
      picturePath: '/assets/img/testimony_activity/web_Image_061.png.webp',
      appBgPath: '/assets/img/testimony_activity/app_Image_06.png',
      contentKey: 'testimony_images_content_6',
      isShow: true,
      icon: '/assets/img/testimony_activity/icon_6.svg',
      createTime: 1620820000010
    },
    {
      titleKey: 'Roger Tasker',
      subTitleKey: 'Roger Tasker PTY LTD',
      countryKey: 'SouthAfrica',
      picturePath: '/assets/img/testimony_activity/web_Image_071.png.webp',
      appBgPath: '/assets/img/testimony_activity/app_Image_07.png',
      contentKey: 'testimony_images_content_7',
      isShow: true,
      icon: '/assets/img/testimony_activity/icon_7.svg',
      createTime: 1620820000010
    }
  ],
  textList: [
    {
      contentKey: 'testimony_1',
      isShow: true,
      createTime: 1620820000010
    },
    {
      contentKey: 'testimony_2',
      isShow: true,
      createTime: 1620820000020
    },
    {
      contentKey: 'testimony_3',
      isShow: true,
      createTime: 1620820000000
    },
    {
      contentKey: 'testimony_4',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_5',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_6',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_7',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_8',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_9',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_10',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_11',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_12',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_13',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_14',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_15',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_16',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_17',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_18',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_19',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_20',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_21',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_22',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_23',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_24',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_25',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_26',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_27',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_28',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_29',
      isShow: true,
      createTime: 1620820004000
    },
    {
      contentKey: 'testimony_30',
      isShow: true,
      createTime: 1620820004000
    }
  ]
};
